import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { menuAside, menuHeader } from '@/menu';
import { mapState, mapActions } from 'vuex';
import indexDb from '@/utils/indexdDB';
export default {
  data: function data() {
    return {
      leftClose: false,
      dialogVisible: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    info: function info(state) {
      return state.user.info;
    },
    game_show_type: function game_show_type(state) {
      return state.user.game_show_type;
    }
  })),
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout', 'ResetRoute'])), {}, {
    mouseenters: function mouseenters() {
      if (this.game_show_type == 1) {
        this.leftClose = true;
      }
    },
    mouseleaves: function mouseleaves() {
      this.leftClose = false;
    },
    resetData: function resetData() {
      var _this = this;

      // const dbInstance = new indexDb();
      this.$DBControls.delIndexDb().then(function (res) {
        _this.$DBControls.init().then(function (db) {
          console.log('数据库初始化成功', db);

          _this.$message.success('已重置数据库'); // 在这里可以进行后续的数据库操作

        }).catch(function (error) {
          console.error('数据库初始化失败', error);
        });
      });
    },

    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    },
    setPageStatus: function setPageStatus(type) {
      this.$store.dispatch('d2admin/serchSelect/setPageStatus', type);
      this.$router.push('/');
    },
    goG: function goG(type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (type == 1) {
                  // this.setPageStatus(type)
                  // let accessMenus = await this.$store.dispatch('d2admin/db/get', {
                  //   dbName: 'sys',
                  //   path: 'menu.accessMenus',
                  //   defaultValue: [],
                  //   user: true
                  // }, {
                  //   root: true
                  // })
                  // let allMenuAside = [...menuAside, ...accessMenus]
                  // let allMenuHeader = [...menuHeader, ...accessMenus]
                  // // 设置顶栏菜单
                  // this.$store.commit('d2admin/menu/headerSet', allMenuHeader)
                  // // 设置侧边栏菜单
                  // this.$store.commit('d2admin/menu/asideSet', allMenuAside)
                  // // 初始化菜单搜索功能
                  // this.$store.commit('d2admin/search/init', allMenuHeader)
                  _this2.$store.dispatch('d2admin/system/gogameIndex');
                }

                if (type == 2) {
                  _this2.setPageStatus(type); // 设置顶栏菜单


                  _this2.$store.commit('d2admin/menu/headerSet', menuHeader); // 设置侧边栏菜单


                  _this2.$store.commit('d2admin/menu/asideSet', menuAside); // 初始化菜单搜索功能


                  _this2.$store.commit('d2admin/search/init', menuHeader);
                }

                if (type == 3) {
                  _this2.ResetRoute();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  })
};